(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('RealtyTypeDialogController', RealtyTypeDialogController);

    RealtyTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RealtyType'];

    function RealtyTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RealtyType) {
        var vm = this;

        vm.realtyType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.realtyType.id !== null) {
                RealtyType.update(vm.realtyType, onSaveSuccess, onSaveError);
            } else {
                RealtyType.save(vm.realtyType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:realtyTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
